module.exports = __webpack_public_path__ + "static/media/matnrrd_2-273w.ac7283e9.png";